import React, { useRef, useState } from "react";
import Cron from "react-cron-generator";
import Draggable from "react-draggable";
import Modal from "../../../../components/common/form/Modal";

interface AddCronExpProps {
  show: boolean;
  setShow: (show: boolean) => void;
  schedule: string;
  setSchedule: (schedule: string) => void;
  isConfigBtn: (value: boolean) => void;
  updateCronIndex: number | null;
  updateSchedule: string;
  setUpdateSchedule: (schedule: string) => void;
}

const AddCronExp: React.FC<AddCronExpProps> = ({
  show,
  setShow,
  schedule,
  setSchedule,
  isConfigBtn,
  updateCronIndex,
  updateSchedule,
  setUpdateSchedule,
}) => {


  return (
    <>

      <Modal
        title="Add Schedule"
        show={show}
        setShow={setShow}
        className="w-2/5 bg-text-0"
        fields={
          <div className="modal-body ">
            {updateCronIndex === null ? (
              <Cron
                onChange={(e: string) => {
                  setSchedule(e);
                }}
                value={schedule}
                showResultText={true}
                showResultCron={true}
              />
            ) : (
              <Cron
                onChange={(e: string) => {
                
                  setSchedule(e);
                }}
                value={updateSchedule}
                showResultText={true}
                showResultCron={true}
              />
            )}
          </div>
        }
      />

    </>

  );
};

export default AddCronExp;
